<template>
  <div class="error-404-wrapper">
    <div class="error-404-inner">
      <div class="error-top text-center">
        <img class="error-logo" :src="logo" alt="ICREA logo" />
      </div>

      <div class="error-content text-center">
        <img class="error-illustration" :src="illustration" alt="Not found illustration" />
      </div>

      <div class="error-bottom text-center">
        <b-button variant="warning" class="btn-go-dashboard" :to="{ path: '/intranet' }">Go to your dashboard</b-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BButton } from 'bootstrap-vue'

export default {
  components: {
    BButton,
  },
  data() {
    return {
      logo: require('@/assets/images/404/404-logo-icrea.svg'),
      illustration: require('@/assets/images/404/404-ilustration.svg'),
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';

.error-404-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 120px);
  padding: 40px 16px;
}

.error-404-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 720px;
  width: 100%;
  min-height: calc(100vh - 160px);
  padding: 40px 0;
}

.error-logo {
  height: 125px;
  margin-bottom: 18px;
}

.error-caption {
  display: inline-block;
  background: #efe9da;
  color: #333;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  margin-bottom: 24px;
}

.error-illustration {
  width: 480px;
  margin-top: 40px;
  max-width: 90%;
}

.btn-go-dashboard {
  background: #b79b3a;
  border-color: #b79b3a;
  color: #fff;
  padding: 10px;
  border-radius: 10px;
  text-decoration: none;;
}

.error-bottom {
  margin-top: 40px;
}

@media (max-width: 576px) {
  .error-illustration {
    width: 320px;
  }
}

</style>
